export const HELP_CONTENT = {
	ec: `ゲストが、「宿泊券の購入」を行なった際に通知するメールアドレスを3つまで登録できます。<br />こちらの設定がない場合、施設情報のメールアドレス宛に通知が送られます。`,
	payment: `こちらのアカウントで「プランの更新」「定額チケットの購入」を行なった際、または、こちらのアカウントに登録している銀行口座に入金が行われた際に通知するメールアドレスを3つまで登録できます。<br />こちらの設定がない場合、施設情報のメールアドレス宛に通知が送られます。`,
	reservation: `ゲストが、「新規予約」「予約の更新」「予約のキャンセル」を行なった際に通知するメールアドレスを3つまで登録できます。<br />こちらの設定がない場合、施設情報のメールアドレス宛に通知が送られます。`,
};
